<template>
  <div id="profile-generator">
    <transition name="vt-fade">
      <div v-if="loading" class="loading">
        <img class="loading__spinner" :src="require('../assets/icons/spinner-third.svg')" alt />
        <p class="loading__text">Loading...</p>
      </div>
    </transition>
    <div id="workspace-container">
      <div class="header">
        <button :id="`buttonBack-${step}`" @click="backClick" :class="[ 'buttonBack', { active: getBackActive }]">Back</button>
        <router-link class="header__link" to="/">
          <img class="header__logo" :src="require('../assets/logo.png')" :class="$route.meta.headerClass" />
        </router-link>
      </div>
      <div id="workspace">
        <!-- @zoom="onZoom" -->
        <croppa class="c1" v-model="croppa" @new-image-drawn="onNewImage" :quality="1" :showRemoveButton="false"
          placeholder="" :prevent-white-space="true" :width="2000" :height="2000" :disable-drag-to-move="step > 1"
          :disable-scroll-to-zoom="step > 1" :disable-rotation="step > 1" canvas-color="transparent"></croppa>

        <img v-show="step >= 1 && imageUploaded" :src="overlays[this.selectedIndex].src" ref="overlay" />

        <canvas v-show="step >= 1 && imageUploaded && overlays[this.selectedIndex].year" class="textCanvas" :width="2000" :height="2000"
          ref="textCanvas"></canvas>
        <div class="select-year" v-show="step === 1 && imageUploaded && overlays[this.selectedIndex].year"
          @click="showYear = !showYear" />
      </div>

      <div class="select-overlay" v-if="step == 1 && imageUploaded">
        <div :class="{overlay:1, selected:this.selectedIndex == 1, year:1}" @click="onOverlaySelect(1)"><img
            src="../assets/select/db-1.png" class="overlay" /></div>
        <div :class="{overlay:1, selected:this.selectedIndex == 2}" @click="onOverlaySelect(2)"><img
            src="../assets/select/db-2.png" class="overlay" /></div>
        <div :class="{overlay:1, selected:this.selectedIndex == 3}" @click="onOverlaySelect(3)"><img
            src="../assets/select/db-3.png" class="overlay" /></div>
        <div :class="{overlay:1, selected:this.selectedIndex == 4}" @click="onOverlaySelect(4)"><img
            src="../assets/select/db-4.png" class="overlay" /></div>
        <div :class="{overlay:1, selected:this.selectedIndex == 5}" @click="onOverlaySelect(5)"><img
            src="../assets/select/db-5.png" class="overlay" /></div>
      </div>

      <div class="year-container" v-show="step === 1 && showYear && imageUploaded && overlays[this.selectedIndex].year">
        <!-- <div class="select-field">
          <select id="enter-year" @change="drawText" v-model="selectedYear">
            <option value="">Select A Year</option>
            <option v-for="(year, key) in years" :key="key" :value="year">{{ year }}</option>
          </select>

          <img src="../assets/icons/caret-down.svg" alt="caret">
        </div> -->
        <p v-for="(year, key) in years" :key="key" :value="year" @click="selectYear(year, $event)">{{ year }}</p>
      </div>

      <button id="uploadPhotoBtn" class="btn" v-if="!imageUploaded" @click="croppa.chooseFile()">Upload My
        Photo</button>

      <div v-if="step === 1 && imageUploaded">
        <p class="focus-text">Adjust Scale and position</p>
        <div id="sliderContainer">
          <img src="../assets/icons/compress.svg" class="word" />
          <vue-slider v-model="sliderVal" v-bind="sliderOptions"></vue-slider>
          <img src="../assets/icons/expand.svg" class="word" />
        </div>
      </div>
      <div id="share-text" class="stepInstructions" v-if="step === 2">
        <div>
          <p class='title'>Share or Download</p>
        </div>
        <div id="ctaButtons">
          <a id="shareFacebook" href="#" @click.prevent="shareFacebook">
            <img src="../assets/icons/facebook-f_b.svg" class="word" />
          </a>
          <a id="shareTwitter" href="#" @click.prevent="shareTwitter">
            <img src="../assets/icons/twitter_b.svg" class="word" />
          </a>
          <a id="downloadBtn" :href="downloadUrl" download="dirty-bird.jpg">
            <img src="../assets/icons/download.svg" class="word" />
          </a>
        </div>
      </div>
      <br />

      <div id="debug-panel" style="visibility: hidden; position: fixed">
        <span id="test-text" ref="testTxt">{{ sVicinity || sTyped }}</span>
      </div>

      <div class="generator-actions" v-if="imageUploaded">
        <!-- <button :id="`buttonBack-${step}`" @click="backClick" :class="[ 'buttonBack', { active: getBackActive }]">
          <img src="../assets/icons/chevron-left.svg" width="20" height="20" class="icon" /> Back
        </button>

        <div class="generator-page">{{ step }}/3</div> -->

        <button :id="`buttonNext-${step}`" @click="nextClick" :class="['btn', { active: getNextActive }]"
          v-if="getNextActive">
          Share or Download
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import overlay from '../assets/generator/overlay-1.png'
import ovDirtyBird from '../assets/generator/overlay/dirty-bird.png'
import ovDirtyBirdSans from '../assets/generator/overlay/dirty-bird_sans.png'
import ovRedHelmet from '../assets/generator/overlay/red-helmet.png'
import ovLondon from '../assets/generator/overlay/london.png'
import ovATL from '../assets/generator/overlay/atl.png'
import ovFrost from '../assets/generator/overlay/frost.png'
import grainyGradient from '../assets/generator/grainy-gradient.png'
import fromTxtImg from '../assets/generator/from.png'
import reppinTxtImg from '../assets/generator/reppin.png'
import underlineTxtImg from '../assets/generator/underline.png'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import axios from '../utilities/axios'
import debug from 'debug'
// import Facebook from '../utilities/social/Facebook'
import Twitter from '../utilities/social/Twitter'

const log = debug('component:ImageGenerator')

const imgs = {
  fromTxt: new Image(),
  reppinTxt: new Image(),
  underlineTxt: new Image(),
}

Vue.use(Croppa)

export default {
  components: {
    VueSlider,
    // Croppa,
  },
  data: function () {
    return {
      loading: false,
      step: 1,
      selectedIndex: 0,
      croppa: {},
      drawYear: 0,
      showYear: false,
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      sTyped: '',
      sVicinity: '',
      overlay: overlay,
      overlays: [
        { src: ovDirtyBird },
        { src: ovDirtyBirdSans, year: true },
        { src: ovRedHelmet },
        { src: ovATL },
        { src: ovFrost },
        { src: ovLondon },
      ],
      grainyGradient: grainyGradient,
      imageUploaded: false,
      shareUrl: '',
      downloadUrl: '',
      placeError: false,
      placeId: null,
      years: [],
      sliderOptions: {
        dotSize: 14,
        width: 'auto',
        height: 4,
        contained: false,
        direction: 'ltr',
        data: null,
        min: 0.5,
        max: 10,
        interval: 0.001,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        // tooltip: 'focus',
        // tooltipPlacement: 'top',
        // tooltipFormatter: void 0,
        useKeyboard: false,
        enableCross: true,
        fixed: false,
        // minRange: void 0,
        // maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        // tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
    }
  },
  directives: {
    insertMessage: (canvasElement, binding, vnode) => {
      // This was part of a mask we may not need now, since Google fixes the vicinity.
    },
  },
  computed: {
    getNextActive () {
      switch (this.step) {
        case 1:
          return this.imageUploaded
        default:
          return false
      }

      // return retVal;
    },
    getBackActive () {
      return this.step > 1 && this.step < 3
    },
  },
  methods: {
    getPopupSize (width = 550, height = 420) {
      let data = {
        width: width,
        height: height,
        letf: 0,
        top: 0,
      }
      let winWidth = window.screen.width
      let winHeight = window.screen.height

      // Set Left
      data.left = Math.round(winWidth / 2 - width / 2)

      // Set Top
      if (winHeight > height) {
        data.top = Math.round(winHeight / 2 - height / 2)
      }

      return data
    },
    shareFacebook () {
      const size = this.getPopupSize(550, 420)
      // const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl)
      const myUrl = `${window.location.protocol}//${window.location.host}`
      const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(myUrl)

      window.open(
        url,
        'intent',
        'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=' +
        size.width +
        ',height=' +
        size.height +
        ',top=' +
        size.top +
        ',left=' +
        size.left
      )
      // Facebook.share(this.shareUrl)
    },
    shareTwitter () {
      const myUrl = `${window.location.protocol}//${window.location.host}`
      Twitter.share(
        // this.shareUrl,
        myUrl,
        `Proud to be a part of the #DirtyBirds”`
      )
    },
    onOverlaySelect (index) {
      this.selectedIndex = index
      if (index !== 1) {
        const canvasElement = this.$refs['textCanvas']
        var ctx = canvasElement.getContext('2d')
        ctx.clearRect(0, 0, 2000, 2000)
      } else {
        this.drawText()
      }
    },
    backClick () {
      // if (!this.getBackActive) return
      if (this.step === 1) {
        if (this.imageUploaded) {
          this.imageUploaded = false
          this.croppa.refresh()
        } else {
          window.location.href = '/'
        }
        return
      } else if (this.step === 2) {
        this.drawText()
      }

      this.step -= 1
    },
    async nextClick () {
      if (!this.getNextActive) {
        if (this.step === 2 && !this.sVicinity) this.placeError = true
        return
      }

      // await this.setupImageDownload()
      // this.step += 1

      this.loading = true
      try {
        if (this.drawYear === 0 && this.overlays[this.selectedIndex].year) {
          this.showYear = true
          this.loading = false
          return
        }
        if (this.step === 1) {
          // const response = await this.submitImage()
          const response = await this.setupImageDownload()
          log(response)

          this.shareUrl = response.shareUrl
          this.downloadUrl = response.downloadUrl
        }
        this.step += 1
      } catch (error) {
        log(error)
      } finally {
        this.loading = false
      }
    },
    isStep (inquery) {
      return this.getStep() === inquery
    },
    selectYear (year, event) {
      this.drawYear = year
      this.showYear = false
      console.log('year', year, event)
      // document.querySelectorAll('.year-container p.selected').classList.toggle('selected')
      document.querySelectorAll('.year-container p.selected').forEach(el => el.classList.toggle('selected'))
      event.target.classList.toggle('selected')
      // this.el.toggleClass('selected')
      this.drawText()
    },
    drawText (final = false) {
      let drawText = this.drawYear // document.getElementById('enter-year').value

      // drawText = drawText.replace(/[^0-9.]/g, '').substring(0, 4)
      //
      // document.getElementById('enter-year').value = drawText

      const canvasElement = this.$refs['textCanvas']

      const unscaledSize = 2000
      const offsetCenter = unscaledSize / 2 + 20 // Compensate for words on either side being different widths.
      const yText = 1760

      var ctx = canvasElement.getContext('2d')
      ctx.clearRect(0, 0, unscaledSize, unscaledSize)
      ctx.fillStyle = 'white'
      ctx.font = "600 120px 'Archivo Black'"
      ctx.textAlign = 'left'

      // if (!this.sVicinity.length && !this.sTyped.length) {
      //   textWidth = 250
      //   ctx.drawImage(
      //     imgs.underlineTxt,
      //     offsetCenter - imgs.underlineTxt.naturalWidth / 2,
      //     yText - 30
      //   )
      // }
      //
      // ctx.drawImage(
      //   imgs.fromTxt,
      //   offsetCenter - textWidth / 2 - 125 - sideMargins,
      //   yText
      // )
      // ctx.drawImage(
      //   imgs.reppinTxt,
      //   offsetCenter + textWidth / 2 + sideMargins,
      //   yText
      // )

      // let drawText
      //
      // if (this.sVicinity) {
      //   drawText = this.sVicinity
      // } else if (this.sTyped) {
      //   drawText = this.sTyped
      // }

      if (drawText > 0) {
        ctx.font = "600 120px 'Archivo Black'"
        // drawText = drawText.replace(/\s+/g, ' ').trim()
        // this.drawYear = drawText
        ctx.fillText(drawText, offsetCenter, yText + 60)
        if (!final) {
          ctx.font = "600 60px 'Archivo Black'"
          ctx.fillText('▼', 1000 + (60 * 6), yText + 60)
        }
      } else {
        ctx.font = "600 80px 'Archivo Narrow'"
        ctx.fillText('SELECT A YEAR ▼', offsetCenter, yText + 60)
        this.drawYear = 0
      }
    },
    async submitImage () {
      const image = await this.download()
      const data = new FormData()
      // console.log(this.croppa.getChosenFile())
      // console.log(image)
      data.append('original', this.croppa.getChosenFile())
      data.append('asset', image)
      // data.append('place_id', this.placeId)

      return new Promise(async (resolve, reject) => {
        try {
          const API_ENDPOINT = 'https://quy4s8l991.execute-api.us-east-1.amazonaws.com/dev/uploads'
          // Get the presigned URL
          const response = await axios({
            method: 'GET',
            url: API_ENDPOINT,
          })
          const data = response.data
          // console.log('Response: ', response)
          // console.log('Uploading: ', image)
          let binary = atob(image.split(',')[1])
          let array = []
          for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i))
          }
          let blobData = new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
          // console.log('Uploading to: ', data.uploadURL)
          await fetch(data.uploadURL, {
            method: 'PUT',
            body: blobData,
          })
          // console.log('Result: ', result)
          // // Final URL for the user doesn't need the query string params
          this.uploadURL = data.uploadURL.split('?')[0]
          this.shareURL = 'https://dy1v6kceaatlg.cloudfront.net/share/' + data.Key
          this.shareURL = this.shareURL.replace('share-image/', '')

          let shareUrl = this.shareURL

          let reader = new FileReader()

          reader.onload = await function () {
            let dataUrl = reader.result
            let base64 = dataUrl.split(',')[1]

            resolve({
              'shareUrl': shareUrl,
              'downloadUrl': 'data:image/jpeg;base64,' + base64,
            })
          }

          reader.readAsDataURL(blobData)
        } catch (error) {
          log(error)
        }
      })
    },
    async setupImageDownload () {
      this.drawText(true)
      const image = await this.download()
      return new Promise(async (resolve, reject) => {
        try {
          let binary = atob(image.split(',')[1])
          let array = []
          for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i))
          }
          let blobData = new Blob([new Uint8Array(array)], { type: 'image/jpeg' })

          let reader = new FileReader()

          reader.onload = await function () {
            let dataUrl = reader.result
            let base64 = dataUrl.split(',')[1]

            this.downloadUrl = 'data:image/jpeg;base64,' + base64

            resolve({
              'downloadUrl': 'data:image/jpeg;base64,' + base64,
            })
          }

          reader.readAsDataURL(blobData)
        } catch (error) {
          log(error)
        }
      })
    },
    download (type, compressionRate) {
      return new Promise((resolve, reject) => {
        const self = this
        this.croppa.generateBlob(blob => {
          const url = URL.createObjectURL(blob)
          const img = new Image()

          img.onload = function () {
            // const a = document.createElement('a')

            const canvas = document.createElement('canvas')
            canvas.width = 2000
            canvas.height = 2000

            const context = canvas.getContext('2d')

            context.drawImage(img, 0, 0, 2000, 2000)
            // context.drawImage(self.$refs.grainyGradient, 0, 0, 2000, 2000)
            context.drawImage(self.$refs.overlay, 0, 0, 2000, 2000)
            if (self.overlays[self.selectedIndex].year) {
              context.drawImage(self.$refs.textCanvas, 0, 0, 2000, 2000)
            }

            const image = canvas.toDataURL('image/jpeg')
            resolve(image)

            // canvas.toBlob(
            //   function (combinedBlob) {
            //     const combinedURL = URL.createObjectURL(combinedBlob)

            //     a.download = 'ATL-Falcons-Reppin-' + self.sVicinity
            //     a.href = combinedURL
            //     a.click()
            //     URL.revokeObjectURL(combinedURL)

            //   },
            //   'image/jpeg',
            //   0.95
            // )
          }

          img.src = url
        }, 'image/png')
      })
    },
    onNewImage () {
      this.imageUploaded = true
      this.selectedIndex = 1
      /**
       * this should work but it doesn't. seems really finiky about scale.
       * Certain scale numbers work and some don't
       */
      // const imageMeta = this.croppa.getMetadata()
      // const newMeta = {
      //   startX: imageMeta.startX,
      //   startY: imageMeta.startY,
      //   scale: imageMeta.scale,
      //   orientation: 1
      // }
      // this.croppa.applyMetadata(newMeta)

      /**
       * Instead, we check the orientation and manually rotate based on that.
       */
      const meta = this.croppa.getMetadata()
      console.log('meta.orientation', meta.orientation)
      if (meta.orientation === 3) {
        this.croppa.rotate(2)
      } else if (meta.orientation === 6) {
        this.croppa.rotate(-1)
      } else if (meta.orientation === 8) {
        this.croppa.rotate(3)
      }

      this.sliderVal = this.croppa.scaleRatio
      this.sliderMin = this.croppa.scaleRatio
      this.sliderMin = 0
      this.sliderMax = this.croppa.scaleRatio * 2
    },
    onSliderChange (evt) {
      var increment = evt.target.value
      this.croppa.scaleRatio = +increment
    },
    handlePlaceChanged () {
      this.placeError = false
      const place = this.autocomplete.getPlace()
      const placeName = this.getPlaceName(place)
      log(place, placeName)

      if (!placeName) {
        this.throwPlaceError()
        return
      }

      this.placeId = place.id
      this.sVicinity = placeName
      this.$nextTick(() => {
        this.drawText()
      })
    },
    throwPlaceError () {
      this.placeError = true
    },
    getPlaceName (place) {
      if (!place.vicinity && !place.address_components) return false

      if (place.vicinity) return place.vicinity

      const addressComponent = place.address_components.find(address =>
        address.types.includes('administrative_area_level_1')
      )
      if (!addressComponent) return false

      return addressComponent.long_name
    },
  },
  mounted: function () {
    for (var key in imgs) {
      if (imgs.hasOwnProperty(key)) {
        imgs[key].onload = this.drawText
      }
    }

    imgs.fromTxt.src = fromTxtImg
    imgs.reppinTxt.src = reppinTxtImg
    imgs.underlineTxt.src = underlineTxtImg

    for (let i = new Date().getFullYear(); i >= 1966; i--) {
      this.years.push(i)
    }
  },
  watch: {
    sTyped: function () {
      this.drawText()
      // console.log('sTyped changed to ' + this.sTyped)
    },
    // sVicinity: function () {
    //   setTimeout(this.drawText, 0)
    //   // console.log('sVicinity changed to ' + this.sVicinity)
    // },
    sliderVal: function () {
      this.croppa.scaleRatio = this.sliderVal
    },
  },
}
</script>

<style lang="scss" scoped>
.select-field {
  display: inline-block;
  margin: 0 auto;
  max-width: 400px;
  position: relative;
  width: 100%;
  // opacity: 0.2;

  img {
    height: 1rem;
    width: 1rem;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    border: none;
    user-select: none;
    // border: 1px solid #fbfbfd;
    // border-radius: 1.5625rem;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #fbfbfd;
    font-size: 1.55rem;
    font-weight: 600;
    font-family: 'Archivo Black', sans-serif;
    -webkit-transition: background 250ms;
    transition: background 250ms;
    height: 2.5rem;
    // max-width: 25rem;
    // padding: 0.5rem 1rem;
    // display: -webkit-box;
    // display: -ms-flexbox;
    // display: flex;
    // -webkit-box-align: center;
    // -ms-flex-align: center;
    // align-items: center;
    // -webkit-box-pack: center;
    // -ms-flex-pack: center;
    // justify-content: center;
    // margin-left: auto;
    // margin-right: auto;
    text-align: left;
    text-transform: uppercase;
    // width: 100%;
    option {
     color: #0f0f0f;
     &:first-of-type {
      &:after {
        content:"▼"
      }
     }
    }
  }
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: row nowrap;
  margin: 20px auto;
  max-width: 400px;

  img {
    height: 50px;
  }
}

#workspace {
  //border: 1px solid white;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1.875rem;
  width: 400px;
  height: 400px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vw - 40px);

  img {
    max-width: 100vw;
    max-height: 100vw;
    width: 100%;
    height: 100%;
  }

  &>* {
    position: absolute;
    display: inline-block;
    left: 0px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  &>canvas, &>img {
    pointer-events: none;
  }
}

#workspace-container {
  width: 100%;
  position: relative;
}

#where-step {
  padding: 0 1rem;
}

.select-overlay {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 20px auto;
  max-width: 380px;

  > .overlay {
    background-color: black;
    width: 50px;
    margin: 0 6%;
    border-radius: 25px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &.selected {
      border: 1px solid #AB192D;
    }
    &:not(.selected) {
      border: 1px solid white;
    }
  }
}

#profile-generator {
  text-align: center;

  &>* {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
  }

  >button {
    white-space: nowrap;
    visibility: hidden;
    &>img.word {
      height:30px;
    }
  }

  >button.active {
    visibility: visible;
  }

  #ctaButtons {
    > a {
      width: 50px;
      height: 50px;
      border-radius: 40px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin: 0 10px;
    }
    img {
      width: 50px;
      height: 50px;
    }
  }

  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;

  >* {
    flex: 0 1 100%;
  }

  >button {
    max-width: 100px;
    background-color: black;
    color: white;
    border: 0;
    font-size: 18px;
    text-transform: uppercase;
    cursor: pointer;
    margin-top: 200px;

    img.icon {
      width: 30px;
      height: 30px;
    }
  }
}

.stepInstructions {
  text-transform: uppercase;
  font-size: 24px;
  display: inline-block;
}

.stepInstructions#share-text {
  cursor: pointer;
}

#sliderContainer {
  max-width: 28rem;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: stretch;

  >img {
    flex-grow: auto;
    width: 20px;
    height: 20px;
    flex-basis: auto;
  }

  >:nth-child(2) {
    flex-grow:1;
  }
}

.vue-slider-process {
  background-color: #AB192D !important;
}

.vue-slider-dot, .vue-slider-dot-handle {
  background-color: #AB192D !important;
}

.vue-slider {
  margin-left: 10px;
  margin-right: 10px;
}

input {
  display: block;
}

input[type=range] {
  width: 422px
}

#test-text, #search-location {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  font-family: 'pure_heartregular';
  font-size: 24.476px;
  border: 1px solid white;
  border-radius: 0;
}

.search-location-container {
  max-width: 100vw;
  padding: 0 1rem;
}

#share-text {
  padding-left: 1.25rem;
  padding-right: 1.25rem;

  .title {
    font-weight: 600;
    font-size: 1.5rem;
    font: 'Tomorrow';
  }
}

.share-or-download {
  width: 18.75rem;
}

#search-location {
  display: block;
  font-family: 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  text-align: center;
  font-size: 16px;
  background-color: #000;
  color: #fff !important;
  height: 34px;
  width: 424px;
  max-width: 100%;

  &::selection {
    background-color: $brandPrimary;
  }
}

input[type=text]:focus {
  outline: 2px solid #AB192D;
}

input:focus {
  outline: 0px solid;
}

::placeholder, ::-ms-input-placeholder, :-ms-input-placeholder {
  // Not working?
  color: #fff;
  opacity: 1;
}

input.error {
  border-color: $brandPrimary !important;
}

.city-error {
  padding: 1rem;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;

  &__spinner {
    width: 3rem;
    margin-bottom: 1rem;
    animation: spin 900ms infinite;
  }

  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
  }
}
</style>

<style lang="scss">
.generator {
  // padding-top: 1.875rem;
  padding: 20px;
}

.vue-slider-dot-handle {
  background-color: $brandPrimary !important;
  border-color: $brandPrimary !important;
}
.vue-slider-process {
  background-color: $brandPrimary !important;
}

#workspace {
  canvas {
    width: 100% !important;
    height: 100% !important;
    max-height: 100vw !important;
    max-width: 100vw !important;
  }
}

.croppa-container {
  background: rgb(51,51,51) url('../assets/profile.jpg') center no-repeat;
  background-size: cover;
}

.generator-actions {
  position: relative;
  margin: 0 auto;
  max-width: 25rem;

  .generator-page {
    line-height: 3.5rem;
  }
}

.buttonBack,
.buttonNext {
  background: none;
  border: 0;
  box-shadow: none;
  color: $brandRed;
  cursor: pointer;
  font-family: $baseFontFamily;
  font-size: 1.25rem;
  text-transform: uppercase;
  // top: 0;
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;

  img {
    height: 2rem;
    // position: relative;
    // top: .5rem;
    transition: all 1s ease-in-out;
    -webkit-transition: all 1s ease-in-out;
    -moz-transition: all 1s ease-in-out;
    -o-transition: all 1s ease-in-out;
    -ms-transition: all 1s ease-in-out;
  }

  &:hover {
    text-decoration: none;
  }
}

.buttonBack {
  left: 0;

  img {
    margin-right: .25rem;
  }

  &:before {
    content: "";
    height: 20px;
    width: 20px;
    transition: all 0.25s ease-in-out;
    border-top: 4px solid $brandRed;
    border-left: 4px solid $brandRed;
    transform: translate(0%, 0) rotate(-45deg);
  }

  &:after {
    left: 2rem;
  }

  &:hover {
    img {
      left: -.25rem;
    }

    &:before {
      border-top: 4px solid #7b1223;
      border-left: 4px solid #7b1223;
    }
  }
}

.buttonNext {
  right: 0;

  img {
    margin-left: .25rem;
  }

  &:after {
    right: 2rem;
    width: 55px
  }

  &:hover {
    img {
      right: -.25rem;
    }
  }
}

.select-year {
  width: 50%;
  height: 2.5rem;
  background-color: transparent;
  bottom: 20px;
  right: 0;
  left: auto;
  cursor: pointer;
}

.year-container {
  left: calc(50% + 40px);
  position: absolute;
  margin: 0 auto;
  margin-bottom: 2rem;
  height: 250px;
  border-radius: 5px;
  overflow: scroll;
  overflow-x: hidden;
  background: white;
  color: black;
  padding: 5px 0;
  // right: 50px;
  bottom: 0px;
  z-index: 9;
  max-width: 300px;
  transform: translate(-50%, 0);
  p {
    padding: 5px 10px;
    cursor: pointer;
    user-select: none;
    font-family: "Archivo", sans-serif;
    &.selected {
      background-color: #E7E7E7;
    }
  }
}
</style>
